<template>
  <div class="default-layout">
   <Header></Header>
    <!-- begin::Body -->
    <div class="body_content m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <!-- BEGIN: Left Aside -->
      <button class="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
        <i class="la la-close"></i>
      </button>

      <sidebar></sidebar>

      <div class="body_content_wrapper m-grid__item m-grid__item--fluid m-wrapper">

      <!-- <subheader></subheader> -->

      <div class="body_content_block m-content">

        <slot/>

      </div>

      </div>

    </div>

    <!-- end:: Body -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/template/Header'
import Footer from '@/components/template/Footer'
import Sidebar from '@/components/template/Sidebar'
// import Subheader from '@/components/template/Subheader'
export default {
  name: 'DefaultLayout',
  components: { Sidebar, Footer, Header },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.body_content {
    height: 100vh;
}
.body_content_block {
    height: 100%;
    overflow-y: auto;
}
</style>
